<div class="account-pages"></div>
<div class="clearfix"></div>
<div class="wrapper-page">
	<div class=" card-box">
		<div class="panel-heading text-center">
			<a href="/"><img src="/style/logo/1" alt="" style="width: 100%;"></img></a>
			<h3>{{TR "Passwort zurücksetzen"}}</h3>
			{{#if errors.error}}
				<div class="alert alert-danger">{{errors.error}}</div>
			{{/if}}
		</div>
		<div class="panel-body">
			<p>
			{{TR "Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten einen Link mit dem Sie ein neues Passwort vergeben können."}}
			</p>
			<form class="form-horizontal m-t-20" action="#" method="post">
				<div class="form-group ">
					<div class="col-xs-12">
						<input id="js-email-input" class="form-control {{#if errors.email}}parsley-error{{/if}}" type="email" name="email" placeholder="{{TR "E-Mail"}}" value="{{formData.email}}" autofocus>
						{{#if errors.email}}
						<ul class="parsley-errors-list filled" id="js-email-error">
							<li class="parsley-required">{{TR "E-Mail ist"}} {{errors.email}}</li>
						</ul>
						{{/if}}
					</div>
				</div>
				<div class="form-group text-center m-t-40">
					<div class="col-xs-12">
						<button class="js-reset btn btn-pink btn-block text-uppercase" type="submit">
							{{TR "Zurücksetzen"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

{{> PARTIAL_FOOTER}}
